import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { ModalContent } from "./InvoiceStyles";
import { translations } from "../../translations/common";

interface ModalProps {
  close(): void;
  pdfUrl(): Promise<string>;
  sendAction?: () => void;
}

const InvoiceModalView: React.FC<ModalProps> = ({
  pdfUrl,
  close,
  sendAction,
}) => {
  const [invoiceUrl, setInvoiceUrl] = useState<string | null>(null);

  useEffect(() => {
    pdfUrl().then(setInvoiceUrl);
  }, [pdfUrl]);

  return (
    <div>
      <Dialog open={true} maxWidth="lg" aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{translations.invoice.modalView.title}</DialogTitle>
        <DialogContent>
          <ModalContent>
            {invoiceUrl && (
              <div>
                <object
                  title="sąskaita"
                  data={invoiceUrl}
                  type="application/pdf"
                  width="1200"
                  height="800"
                >
                  <iframe
                    title="sąskaita"
                    src={invoiceUrl}
                    width="1200"
                    height="800"
                  >
                    <p>{translations.invoice.modalView.browserNotSupported}</p>
                  </iframe>
                </object>
              </div>
            )}
          </ModalContent>
        </DialogContent>
        <DialogActions>
          <Button type="submit" variant="contained" onClick={close}>
            {translations.invoice.modalView.close}
          </Button>
          {sendAction && (
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => {
                sendAction();
              }}
            >
              {translations.invoice.modalView.send}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default InvoiceModalView;
